import React from 'react';
import { GetServerSideProps } from 'next';

const AppleFile: React.FC = () => null;

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  /* 
        Keeping this FF check simple here and not inline with how other feature flags work
        because we can't use the useFeatureFlags inside getServerSideProps.

        This is purely in place as a proof of concept and will be removed once working.
    */
  if (process.env.NEXT_PUBLIC_FF_APPLE_PAY !== 'true') {
    return {
      props: {},
    };
  }

  if (res) {
    res.setHeader('Content-Type', 'application/octet-stream');
    res.setHeader(
      'Content-Disposition',
      `attachment; filename=apple-developer-merchantid-domain-association`
    );

    const fileContent = process.env.APPLE_FILE;

    res.write(fileContent || 'some placeholder file');
    res.end();
  }

  return {
    props: {},
  };
};

export default AppleFile;
